import React from 'react'
import Line from './Line'

function ContactLine({ text }) {
    return (
        <p className="font-raleway font-body_text text-l">{text}</p>
    )
}

function Contact() {
    return (
        <div className="flex justify-center w-full">
            <div className="w-full">
                <div className="flex justify-center">
                <Line length="96%" color="#82A3FF"></Line>

                </div>
                <h1 className="pl-[6%] text-3xl font-cram font-medium text-headers mb-2">
                    Contact
                </h1>
                <div className="flex justify-between mb-2">
                    <div className="pl-[6%]">
                    <p className="font-raleway font-semibold text-l">Email:</p>
                    <ContactLine text="evaintoci@gmail.com" />
                    <p className="font-raleway font-semibold text-l">Phone:</p>
                    <ContactLine text="(510)990-5714" />
                    </div>
                    <div className="flex items-center pr-2 -mt-4 sm:pr-[20%]">
    <div className="flex items-center gap-5">
        <img
            src="/images/Linkedin.svg"
            alt="linkedin"
            className="w-auto h-8"
        />
        <a
    href="https://www.linkedin.com/in/eva-intoci-784461305"
    className="underline font-raleway text-big_text w-24 sm:w-auto"
>
    Connect with me on Linkedin
</a>
    </div>
</div>
                </div>

            </div>
        </div>
    )
}
export default Contact
